// extracted by mini-css-extract-plugin
export var chip = "_54-9";
export var chipLabel = "_54-a";
export var close = "_54-7";
export var closeIcon = "_54-8";
export var error = "_54-6";
export var infoTooltip = "_54-2";
export var innerContainer = "_54-1";
export var input = "_54-b";
export var medium = "_54-5";
export var outerContainer = "_54-0";
export var small = "_54-4";
export var xSmall = "_54-3";